import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowLeft } from 'lucide-react';
import EnhancedEditInvoiceForm from '@/components/invoices/EnhancedEditInvoiceForm';
import PageLayout from '@/components/layout/PageLayout';

const EditInvoicePage = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <PageLayout maxWidth="md" padding="md">
        <Card>
          <CardContent className="p-6">
            <p className="text-destructive">No invoice ID provided.</p>
            <Button asChild className="mt-4">
              <Link to="/invoices">Back to Invoices</Link>
            </Button>
          </CardContent>
        </Card>
      </PageLayout>
    );
  }

  return (
    <PageLayout maxWidth="xl" padding="md">
      <div className="flex items-center gap-2 mb-6">
        <Button variant="ghost" size="sm" asChild>
          <Link to={`/invoices/${id}`}>
            <ArrowLeft className="h-4 w-4 mr-1" />
            Back to Invoice
          </Link>
        </Button>
      </div>
      <Card>
        <CardContent className="pt-6">
          <EnhancedEditInvoiceForm invoiceId={id} />
        </CardContent>
      </Card>
    </PageLayout>
  );
};

export default EditInvoicePage;
